import React from "react"
import AddonSwitch from "@features/Price/Addons/AddonSwitch"
import * as styles from "./style.module.scss"

interface AddonDropdownProps {
  id: string
  bucket: string
  checked: boolean
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  selectedPrice: number
  selectedCount?: number
  localIndex: number
  options: number[]
  prices: number[]
  unitLabel: string
  itemLabel: string
  hint: {
    title: string
    content: React.ReactNode
  }
  handleToggle: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleSelect: (index: number) => void
  withModuleWrapper: boolean
  hideMainSwitch: boolean
}

const AddonDropdown = ({
  id,
  bucket,
  checked,
  open,
  setOpen,
  selectedPrice,
  selectedCount,
  localIndex,
  options,
  prices,
  unitLabel,
  itemLabel,
  hint,
  handleToggle,
  handleSelect,
  withModuleWrapper,
  hideMainSwitch,
}: AddonDropdownProps) => {
  const dropdownLabel = `${selectedCount?.toLocaleString("ru-RU")} ${unitLabel}`

  return (
    <div className={withModuleWrapper ? styles.moduleWrapper : undefined}>
      <AddonSwitch id={id} bucket={bucket} checked={checked} onChange={handleToggle} className={hideMainSwitch ? "" : ""} />

      <div>
        <div className={styles.dropdownToggleWrapper}>
          <div className={styles.dropdownToggle} onClick={() => setOpen((prev) => !prev)}>
            <div>
              <span>{dropdownLabel}&nbsp;</span>
              <span>{selectedPrice.toLocaleString("ru-RU")}&nbsp;₽/мес</span>
            </div>

            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M4 6L8 10L12 6" stroke="black" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
            </svg>

            <AddonSwitch id={id} bucket={bucket} checked={checked} onChange={handleToggle} className={styles.secondarySwitch} />
          </div>

          <p className={styles.hint}>
            {hint.title}
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" width="9" height="5" viewBox="0 0 9 5" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M4.33337 0.0820312L8.33337 4.08203H0.333374L4.33337 0.0820312Z" fill="black" fillOpacity="0.8" />
              </svg>
              {hint.content}
            </span>
          </p>
        </div>

        {open && (
          <ul className={styles.dropdownList}>
            {options.map((count, idx) => (
              <li
                key={`${count}-${idx}`}
                className={`${styles.dropdownItem} ${idx === localIndex ? styles.dropdownItemActive : ""}`}
                onClick={() => {
                  handleSelect(idx)
                  setOpen(false)
                }}
              >
                {count.toLocaleString("ru-RU")} {itemLabel} — {prices[idx].toLocaleString("ru-RU")} ₽
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  )
}

export default AddonDropdown
